import apiAthleteScholarships from '@/api/athlete-scholarship'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  createAthleteScholarshipStart:
    '[create athlete scholarship] Create athlete scholarship start',
  createAthleteScholarshipSuccess:
    '[create athlete scholarship] Create athlete scholarship success',
  createAthleteScholarshipFailure:
    '[create athlete scholarship] Create athlete scholarship failure'
}

export const actionTypes = {
  createAthleteScholarship:
    '[create athlete scholarship] Create athlete scholarship'
}

const mutations = {
  [mutationTypes.createAthleteScholarshipStart](state) {
    state.isSubmitting = true
    state.error = null
  },

  [mutationTypes.createAthleteScholarshipSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createAthleteScholarshipFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.createAthleteScholarship](context, {athleteScholarship}) {
    context.commit(mutationTypes.createAthleteScholarshipStart)
    return new Promise(resolve => {
      apiAthleteScholarships
        .createAthleteScholarship(athleteScholarship)
        .then(response => {
          context.commit(mutationTypes.createAthleteScholarshipSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.createAthleteScholarshipFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
